export default "__VITE_ASSET__ZlDs$4_o__"